import { render } from "./ShoppingPaymentBox.vue?vue&type=template&id=7c6741cc"
import script from "./ShoppingPaymentBox.vue?vue&type=script&lang=js"
export * from "./ShoppingPaymentBox.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__